import { EnvironmentProviders } from '@angular/core';
import { provideInsightPanel } from './insight-panel';
import { PowerInsightPanelComponent, roomHasPowerDevices } from './panels/power-insight-panel.component';
import { OccupancyInsightPanelComponent, roomHasUsage } from './panels/occupancy-insight-panel.component';
import { FeedbackInsightPanelComponent, roomHasFeedback } from './panels/feedback-insight-panel.component';

/**
 * Insight panels available in the cloud portal. Add a panel per new metric type here - the room
 * tab named by `tab` (Room Usage or Power) picks it up automatically.
 */
export function provideCloudInsightPanels(): EnvironmentProviders[] {
    return [
        provideInsightPanel({
            id: 'occupancy',
            tab: 'usage',
            labelKey: 'occupancy.panelTitle',
            icon: 'fa fa-users',
            order: 5,
            span: 'full',
            component: OccupancyInsightPanelComponent,
            isAvailable: roomHasUsage
        }),
        provideInsightPanel({
            id: 'power',
            tab: 'power',
            labelKey: 'power.panelTitle',
            icon: 'fa fa-plug-circle-bolt',
            order: 10,
            span: 'full',
            component: PowerInsightPanelComponent,
            isAvailable: roomHasPowerDevices
        }),
        provideInsightPanel({
            id: 'feedback',
            tab: 'feedback',
            labelKey: 'feedback.panelTitle',
            icon: 'fa fa-star',
            order: 5,
            span: 'full',
            component: FeedbackInsightPanelComponent,
            isAvailable: roomHasFeedback
        })
    ];
}
